import { render, staticRenderFns } from "./UserDetails.html?vue&type=template&id=d28aa42e&scoped=true&"
import script from "./UserDetails.js?vue&type=script&lang=js&"
export * from "./UserDetails.js?vue&type=script&lang=js&"
import style0 from "./UserDetails.scss?vue&type=style&index=0&id=d28aa42e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28aa42e",
  null
  
)

export default component.exports